// extracted by mini-css-extract-plugin
export default {"actions":"LanguageConfirmationModal-actions","cancel":"LanguageConfirmationModal-cancel"};